import { createContext } from 'react';

const CursorContext = createContext();

export default CursorContext;